@if (open()) {
  @let panelWidth = typeof width() === 'number' ? `${width()}px` : width();

  <div
    upuAutoFocus
    role="dialog"
    tabindex="-1"
    class="outline-none fixed inset-0 bg-black/30 animate-fade-in z-[1000]"
    [class.animate-fade-out]="markForClose()"
    (animationend)="closeAnimationEnd($event)"
    (keyup)="(null)"
    (click)="dismissible() && $event.target === $event.currentTarget && close()"
    (window:keydown.escape)="dismissible() && close()"
  >
    <aside
      *upuTranslate="let t"
      aria-live="polite"
      class="absolute top-0 bottom-0 max-w-full p-3 will-change-transform outline-none"
      [class.animate-slide-in-from-right]="position() === 'right'"
      [class.animate-slide-in-from-left]="position() === 'left'"
      [class.animate-slide-out-to-right]="
        position() === 'right' && markForClose()
      "
      [class.animate-slide-out-to-left]="
        position() === 'left' && markForClose()
      "
      [class.left-0]="position() === 'left'"
      [class.right-0]="position() === 'right'"
    >
      <div
        class="relative flex flex-col max-w-full h-full bg-main overflow-hidden rounded-xl shadow-lg"
        [style.width]="panelWidth"
      >
        <!-- Header -->
        <header
          #headerEle
          class="absolute top-0 left-0 frost-effect-lg z-10 w-full flex flex-col gap-4 px-6 py-4 shrink-0 after:absolute after:inset-0 after:opacity-0 after:transition-opacity [&.active-scroll-style]:after:opacity-100 after:-z-[1] after:border-b after:border-black/10 after:duration-200 after:shadow-md"
          [class.active-scroll-style]="hasScrolled()"
          [class.items-center]="!headerTemplate()"
        >
          <div class="w-full flex items-center gap-2">
            <h2
              class="w-fit font-medium text-[#002B41] text-lg truncate leading-tight select-none"
            >
              {{ title() }}
            </h2>

            <button
              id="close-button"
              mat-icon-button
              type="button"
              class="ml-auto rtl:ml-0 rtl:mr-auto icon-button icon-button-md text-[#49454F]"
              [attr.aria-label]="t('common.close')"
              (click)="close()"
            >
              <mat-icon class="text-2xl">close</mat-icon>
            </button>
          </div>

          @if (headerTemplate()) {
            <ng-container [ngTemplateOutlet]="headerTemplate()" />
          }
        </header>

        <!-- Content -->
        <section
          upuScrollObserver
          [(hasScrolled)]="hasScrolled"
          [scrollSentinelId]="'side-panel-observer'"
          [style.paddingTop.px]="headerHeight()"
          class="bg-main flex-1 px-6 pb-6 outline-none overflow-hidden overflow-y-auto"
          tabindex="-1"
        >
          <ng-content />
        </section>

        <!-- Footer -->
        @if (footerTemplate()) {
          <footer
            class="bg-main relative z-10 w-full px-6 py-4 border-t border-black/10"
          >
            <ng-container [ngTemplateOutlet]="footerTemplate()" />
          </footer>
        }
      </div>
    </aside>
  </div>
}
